// SOEM Partners Group - Datos del sitio

export const companyInfo = {
  name: "SOEM Partners Group",
  tagline: "Seguridad estratégica para eventos de alto nivel",
  subtitle: "Metodología, experiencia y criterio técnico documentado",
  email: "hola@soempg.com",
  phone: "+52 56 3410 3631",
  address: "Ciudad de México, México"
};

export const heroContent = {
  title: "Seguridad estratégica para eventos de alto nivel",
  subtitle: "Consultoría especializada en planeación, evaluación y gestión de riesgos con metodología documentada y enfoque preventivo.",
  cta: "Solicitar información"
};

export const valueBlocks = [
  {
    id: 1,
    title: "Diagnóstico",
    description: "Evaluación integral de riesgos y vulnerabilidades específicas de cada evento.",
    icon: "Search"
  },
  {
    id: 2,
    title: "Cumplimiento",
    description: "Alineación con normativas, estándares y mejores prácticas del sector.",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Prevención",
    description: "Estrategias proactivas para anticipar y mitigar incidentes potenciales.",
    icon: "AlertTriangle"
  }
];

export const eventTypes = [
  { id: 1, name: "Eventos Deportivos", icon: "Trophy" },
  { id: 2, name: "Conciertos y Espectáculos", icon: "Music" },
  { id: 3, name: "Eventos Corporativos", icon: "Building" },
  { id: 4, name: "Convenciones", icon: "Users" },
  { id: 5, name: "Eventos Académicos", icon: "GraduationCap" },
  { id: 6, name: "Eventos Masivos", icon: "Layers" }
];

export const aboutContent = {
  history: "SOEM Partners Group surge de la necesidad de profesionalizar la seguridad en eventos de alto nivel en México y Latinoamérica. Fundada por especialistas con amplia trayectoria en gestión de riesgos, protección civil y coordinación operativa, la empresa se ha consolidado como referente en consultoría estratégica de seguridad.",
  philosophy: "La seguridad efectiva no es reactiva, es estratégica. En SOEM Partners Group, cada decisión se fundamenta en análisis técnico, metodología probada y documentación rigurosa. El objetivo no es únicamente proteger, sino anticipar, prevenir y gestionar.",
  whatWeAre: [
    "Consultores especializados en seguridad estratégica",
    "Analistas de riesgos con enfoque metodológico",
    "Expertos en coordinación interinstitucional",
    "Profesionales en gestión de crisis y emergencias"
  ],
  whatWeAreNot: [
    "Empresa de seguridad privada tradicional",
    "Proveedores de guardias o escoltas",
    "Servicios de vigilancia reactiva",
    "Soluciones genéricas sin análisis previo"
  ]
};

export const methodology = {
  intro: "La Metodología SOEM es un marco de trabajo integral que garantiza la gestión sistemática de la seguridad en cada fase del evento.",
  phases: [
    {
      id: 1,
      name: "Pre-evento",
      title: "Evaluación y Planeación",
      items: [
        "Análisis del contexto y entorno",
        "Identificación de amenazas y vulnerabilidades",
        "Evaluación de riesgos específicos",
        "Diseño del plan de seguridad",
        "Coordinación con stakeholders"
      ]
    },
    {
      id: 2,
      name: "Durante el evento",
      title: "Supervisión y Control",
      items: [
        "Monitoreo en tiempo real",
        "Coordinación operativa",
        "Gestión de incidentes",
        "Comunicación con autoridades",
        "Documentación continua"
      ]
    },
    {
      id: 3,
      name: "Post-evento",
      title: "Análisis y Mejora",
      items: [
        "Evaluación de desempeño",
        "Análisis de incidentes",
        "Identificación de oportunidades",
        "Reporte ejecutivo",
        "Recomendaciones de mejora"
      ]
    }
  ],
  principles: [
    "Enfoque preventivo sobre reactivo",
    "Decisiones basadas en análisis técnico",
    "Documentación y trazabilidad completa",
    "Mejora continua basada en evidencia"
  ]
};

export const services = [
  {
    id: 1,
    title: "Consultoría en Seguridad para Eventos",
    description: "Asesoramiento estratégico integral para la planeación y ejecución de eventos seguros.",
    forWhom: "Organizadores de eventos, productoras, recintos y corporativos.",
    deliverable: "Plan estratégico de seguridad personalizado con análisis de riesgos y recomendaciones específicas."
  },
  {
    id: 2,
    title: "Evaluación y Diagnóstico de Riesgos",
    description: "Identificación sistemática de amenazas, vulnerabilidades y niveles de riesgo específicos del evento.",
    forWhom: "Eventos de cualquier escala que requieran un análisis técnico previo.",
    deliverable: "Informe de diagnóstico con matriz de riesgos, mapa de calor y priorización de acciones."
  },
  {
    id: 3,
    title: "Auditoría Técnica de Seguridad",
    description: "Revisión exhaustiva de los protocolos, procedimientos y recursos de seguridad existentes.",
    forWhom: "Recintos, organizadores recurrentes y eventos con historial operativo.",
    deliverable: "Informe de auditoría con hallazgos, brechas identificadas y plan de acción correctivo."
  },
  {
    id: 4,
    title: "Acompañamiento Operativo",
    description: "Presencia de especialistas durante el evento para supervisión, coordinación y toma de decisiones.",
    forWhom: "Eventos de alto perfil o complejidad que requieren expertise in situ.",
    deliverable: "Supervisión especializada, bitácora de evento y reporte post-evento."
  },
  {
    id: 5,
    title: "Capacitación Especializada",
    description: "Programas de formación para equipos de seguridad, staff operativo y personal de coordinación.",
    forWhom: "Equipos internos de seguridad, personal de recintos y organizadores.",
    deliverable: "Programa de capacitación, material didáctico y certificación de participantes."
  }
];

export const integralSecurity = [
  {
    id: 1,
    title: "Contexto del Evento",
    description: "Análisis del entorno geográfico, social, político y mediático que rodea al evento.",
    icon: "MapPin"
  },
  {
    id: 2,
    title: "Seguridad Física",
    description: "Protección de personas, control de accesos, flujos de asistentes y gestión de multitudes.",
    icon: "Users"
  },
  {
    id: 3,
    title: "Seguridad Electrónica",
    description: "Sistemas de videovigilancia, control de acceso electrónico y monitoreo centralizado.",
    icon: "Camera"
  },
  {
    id: 4,
    title: "Seguridad Patrimonial",
    description: "Protección de activos, equipamiento, mercancía y bienes materiales del evento.",
    icon: "Package"
  },
  {
    id: 5,
    title: "Manejo de Emergencias",
    description: "Protocolos de respuesta ante incidentes médicos, evacuaciones y contingencias.",
    icon: "AlertCircle"
  },
  {
    id: 6,
    title: "Manejo de Crisis",
    description: "Gestión de situaciones críticas, comunicación de crisis y toma de decisiones bajo presión.",
    icon: "Zap"
  },
  {
    id: 7,
    title: "Coordinación con Autoridades",
    description: "Vinculación con policía, bomberos, paramédicos y entidades gubernamentales.",
    icon: "Building2"
  },
  {
    id: 8,
    title: "Protección Civil y Cumplimiento",
    description: "Alineación con normativas locales, permisos y requisitos de protección civil.",
    icon: "FileCheck"
  }
];

export const reports = [
  {
    id: 1,
    title: "Resumen Ejecutivo",
    description: "Síntesis de hallazgos clave, conclusiones principales y recomendaciones prioritarias para la toma de decisiones."
  },
  {
    id: 2,
    title: "Diagnóstico Técnico",
    description: "Análisis detallado de riesgos, vulnerabilidades identificadas y evaluación del contexto de seguridad."
  },
  {
    id: 3,
    title: "Vías de Oportunidad",
    description: "Identificación de áreas de mejora y oportunidades para fortalecer la postura de seguridad."
  },
  {
    id: 4,
    title: "Recomendaciones",
    description: "Propuestas específicas, priorizadas y accionables para mitigar riesgos identificados."
  },
  {
    id: 5,
    title: "Reporte Pre-evento",
    description: "Documento previo con plan de seguridad, protocolos definidos y matriz de responsabilidades."
  },
  {
    id: 6,
    title: "Reporte Post-evento",
    description: "Evaluación de desempeño, análisis de incidentes y lecciones aprendidas para eventos futuros."
  }
];

export const technology = {
  intro: "La tecnología es una herramienta fundamental en la gestión moderna de seguridad, pero nunca sustituye el criterio humano ni la toma de decisiones informada.",
  areas: [
    {
      id: 1,
      title: "Digitalización de Procesos",
      description: "Automatización de flujos de trabajo, gestión documental y comunicación en tiempo real."
    },
    {
      id: 2,
      title: "Indicadores y Métricas",
      description: "Medición del desempeño, KPIs de seguridad y dashboards para toma de decisiones."
    },
    {
      id: 3,
      title: "Mejora Continua",
      description: "Análisis de datos históricos para identificar patrones y optimizar estrategias."
    },
    {
      id: 4,
      title: "Seguridad de la Información",
      description: "Protección de datos sensibles, confidencialidad y cumplimiento de normativas de privacidad."
    }
  ],
  disclaimer: "En SOEM Partners Group, la tecnología potencia el análisis y la eficiencia operativa, pero las decisiones críticas siempre recaen en profesionales capacitados con criterio y experiencia."
};

export const clients = {
  sectors: [
    "Entretenimiento y espectáculos",
    "Deportes profesionales",
    "Corporativo y empresarial",
    "Gobierno e instituciones",
    "Educación y academia",
    "Cultura y artes"
  ],
  clientTypes: [
    "Productoras de eventos",
    "Recintos y venues",
    "Federaciones deportivas",
    "Empresas y corporativos",
    "Instituciones educativas",
    "Organizaciones gubernamentales"
  ],
  experience: "Más de una década de experiencia en eventos de diversa escala y complejidad, desde reuniones ejecutivas hasta eventos masivos con decenas de miles de asistentes."
};

export const legalContent = {
  privacy: {
    title: "Aviso de Privacidad",
    content: `SOEM Partners Group, con domicilio en Ciudad de México, México, es responsable del tratamiento de los datos personales que nos proporcione.

Los datos personales que recabamos serán utilizados para las siguientes finalidades:
- Atención a solicitudes de información
- Elaboración de propuestas de servicios
- Comunicación relacionada con nuestros servicios
- Cumplimiento de obligaciones legales

No compartimos su información personal con terceros sin su consentimiento previo, salvo en los casos previstos por la ley.

Usted tiene derecho a acceder, rectificar y cancelar sus datos personales, así como a oponerse al tratamiento de los mismos. Para ejercer estos derechos, puede contactarnos a través de nuestro correo electrónico.

Nos reservamos el derecho de modificar este aviso de privacidad en cualquier momento.`
  },
  terms: {
    title: "Términos de Uso",
    content: `El acceso y uso de este sitio web está sujeto a los siguientes términos y condiciones:

1. El contenido de este sitio es únicamente informativo y no constituye una oferta de servicios.

2. La información presentada es propiedad de SOEM Partners Group y está protegida por las leyes de propiedad intelectual.

3. Queda prohibida la reproducción total o parcial del contenido sin autorización previa por escrito.

4. SOEM Partners Group no garantiza la disponibilidad continua del sitio web.

5. Los enlaces a sitios externos son proporcionados como referencia y no implican respaldo o responsabilidad sobre su contenido.

6. El uso de este sitio implica la aceptación de estos términos y del aviso de privacidad.`
  }
};

export const navigation = [
  { name: "Inicio", path: "/" },
  { name: "Quiénes Somos", path: "/about" },
  { name: "Metodología", path: "/methodology" },
  { name: "Servicios", path: "/services" },
  { name: "Seguridad Integral", path: "/integral-security" },
  { name: "Contacto", path: "/contact" }
];

export const footerNavigation = [
  { name: "Tipos de Eventos", path: "/event-types" },
  { name: "Reportes", path: "/reports" },
  { name: "Tecnología", path: "/technology" },
  { name: "Clientes", path: "/clients" },
  { name: "Aviso Legal", path: "/legal" }
];
